<template>
  <div class="cs-relatedWorkflow">
    <el-table
      stripe
      v-loading="loading"
      :data="tableData"
      ref="relatedWorkflowTable"
      @select="onCheckChange"
    >
      <el-table-column
        v-if="!isReadonly"
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        prop="Order"
        label=""
        width="60"
      >
      </el-table-column>
      <el-table-column
        prop="DateText"
        label="报名日期"
        width="180"
      >
      </el-table-column>
      <el-table-column
        label="关联"
        width="180"
      >
        <template slot-scope="scope">
          {{getRelatedWorkflow(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column
        label="课程"
        width="220"
        class-name="cs-relatedWorkflow-courseListCol"
      >
        <template slot-scope="scope">
          <ul class="cs-relatedWorkflow-courseList">
            <li
              v-for="course in scope.row.CourseList"
              :key="course.Id"
            >{{course.Name}}</li>
          </ul>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss">
.cs-relatedWorkflow {
  label {
    margin-bottom: 0;
  }
  th.el-table-column--selection {
    .el-checkbox {
      display: none;
    }
  }

  .cs-relatedWorkflow-courseListCol{
    .cell{
      overflow: visible;
    }
  }
}
</style>

<style lang="scss" scoped>
.cs-relatedWorkflow {
  padding: 10px;



  .cs-relatedWorkflow-courseList{
    margin-bottom: 0;
    padding: 0;
    li{
      list-style-type:none;
      white-space: nowrap;
    }
  }
}

</style>

<script>
import { getWorkflowCoursesInTerm } from "../../../service/enrollmentFee.service";
export default {
  props: {
    isReadonly:Boolean,
    dataIn: {
      workflowId: Number,
      studentId: Number,
      termId: Number,
      relatedIdList: Array,
      taxModel: Object,
      relatedWorkflowType: Number,
      relatedInTermDiscountId: Number,
    }
  },
  data() {
    return {
      loading: false,
      totalList:[],
      tableData: [],
      selectedIdList: []
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.studentId && !!this.dataIn.termId) {
        this.loading = true;
        if (!!this.dataIn && !!this.dataIn.relatedIdList) {
          this.selectedIdList = this.dataIn.relatedIdList;
        } else {
          this.selectedIdList = [];
        }
        getWorkflowCoursesInTerm(this.dataIn.studentId, this.dataIn.termId)
          .then(result => {
            if (!!result && result.success) {
              this.totalList = result.data;
              this.loadList();
              // if (!!this.dataIn.workflowId) {
              //   let workflow = listData.find(
              //     i => i.Id == this.dataIn.workflowId
              //   );
              //   if (!!workflow && !!workflow.RelatedId) {
              //     this.relatedIdList = this.tableData
              //       .filter(i => i.RelatedId == row.RelatedId)
              //       .map(i => i.Id);
              //   }
              // }
              this.$nextTick(()=>{
                this.selectRows(this.selectedIdList, true);
              });
             
            }
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
          });
      } else {
        this.tableData = [];
      }
    },
    loadList(){
      if (this.isReadonly){
        this.tableData = this.totalList.filter(
          i => this.dataIn.relatedIdList.indexOf(i.Id) >= 0 
        );
      }else{
          this.tableData = this.totalList.filter(
            i => i.Id != this.dataIn.workflowId && i.RelatedInTermDiscountId == this.dataIn.relatedInTermDiscountId
             //i.RelatedWorkflowType == this.dataIn.relatedWorkflowType
        );
      }
    
    },
    getRelatedWorkflow(row) {
      if (!!row.RelatedId) {
        let list = this.tableData.filter(i => i.RelatedId == row.RelatedId);
        let str = list.map(i => i.Order).join(",");
        return str;
      }
      return "";
    },
    selectRows(relatedIdList, isChecked) {      
      relatedIdList.forEach(id => {
        if (!!id) {
          let row = this.tableData.find(i => i.Id == id);
          if (!!row) {
            this.$refs.relatedWorkflowTable.toggleRowSelection(row, isChecked);
          }
        }
      });
    },
    onCheckChange(selection, row) {
      let isChecked = selection.indexOf(row) >= 0;
      let relatedIdList = this.getRelatedWorkflowIdList(row);
    
      relatedIdList.forEach(element => {
        let index = this.selectedIdList.indexOf(element);
        if (isChecked){
          if (index < 0){
            this.selectedIdList.push(element);
          }
        }else{
          if (index >= 0){
            this.selectedIdList.splice(index, 1);
          }
        }
      });

      this.selectRows(relatedIdList, isChecked);
      this.setHasTax();
      this.$emit("selectedWorkflowChange");
    },
    getRelatedWorkflowIdList(row) {
      let relatedWorkflowList = [];
    
      if (!!row.RelatedId) {
        relatedWorkflowList = this.tableData
          .filter(i => i.RelatedId == row.RelatedId)
          .map(i => i.Id);
      } else {
        relatedWorkflowList.push(row.Id);
      }
        
      return relatedWorkflowList;
    },
    getSelectedWorkflow() {
      return this.selectedIdList;
    },
    clearSelection(){
      this.selectedIdList = [];
      this.setHasTax();
    },
    setHasTax(){
      if (!!this.dataIn && !!this.dataIn.taxModel){
        let hasTaxSetting = false;
        if (this.selectedIdList.length > 0){
          let list = this.tableData.filter(i => this.selectedIdList.indexOf(i.Id)>=0 && i.HasTax);
          let hasTax = list.length > 0;
          this.$set(this.dataIn.taxModel, "hasTax", hasTax);
        }else{
          hasTaxSetting = true;
        }
        this.$set(this.dataIn.taxModel, "hasTaxSetting", hasTaxSetting);  
      }
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    },
    isReadonly: function(){

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/relatedWorkflowList.vue